import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  TextField,
  CircularProgress,
  Snackbar,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../../../../config/firebase";
import ModalDialogTitle from "../../../common/ModalDialogTitle";
import ModalActions from "../../../common/ModalActions";

const AddForm = ({ open, handleClose, onResourceAdded }) => {
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    link: "",
    icon: "",
    iconColor: "",
  });

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const validateUrl = (url) => {
    const pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))" + // domain name and extension
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    );
    return !!pattern.test(url);
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    let { link } = formData;
    if (!validateUrl(link)) {
      alert("Please enter a valid URL");
      return;
    }
    if (!link.startsWith("http://") && !link.startsWith("https://")) {
      link = "https://" + link;
    }
    setLoading(true);
    try {
      await addDoc(collection(db, "resources"), { ...formData, link });
      setLoading(false);
      setSnackbarOpen(true);
      onResourceAdded(); // Call the function to update the list
      handleClose(); // Close the dialog after adding the resource
      setFormData({
        title: "",
        link: "",
        icon: "",
        iconColor: "",
      }); // Clear the form values
    } catch (error) {
      console.error("Error adding document:", error);
      setLoading(false);
    }
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <ModalDialogTitle onClose={handleClose}>Add Resource</ModalDialogTitle>
        <DialogContent>
          {loading ? (
            <CircularProgress />
          ) : (
            <form onSubmit={handleSubmit}>
              <TextField
                margin="dense"
                label="Title"
                name="title"
                fullWidth
                value={formData.title}
                onChange={handleChange}
              />
              <TextField
                margin="dense"
                label="Link"
                name="link"
                fullWidth
                value={formData.link}
                onChange={handleChange}
              />
              <FormControl fullWidth margin="dense">
                <InputLabel shrink>Icon</InputLabel>
                <TextField
                  name="icon"
                  value={formData.icon}
                  onChange={handleChange}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </FormControl>
              <FormControl fullWidth margin="dense">
                <InputLabel>Icon Color</InputLabel>
                <Select
                  name="iconColor"
                  value={formData.iconColor}
                  onChange={handleChange}
                >
                  <MenuItem value="red">Red</MenuItem>
                  <MenuItem value="blue">Blue</MenuItem>
                  <MenuItem value="yellow">Yellow</MenuItem>
                  <MenuItem value="orange">Orange</MenuItem>
                  <MenuItem value="purple">Purple</MenuItem>
                  <MenuItem value="green">Green</MenuItem>
                </Select>
              </FormControl>
            </form>
          )}
        </DialogContent>
        <ModalActions onSave={handleSubmit} saving={loading} saveLabel="Submit" />
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ backgroundColor: "black", color: "white", width: "100%" }}
        >
          Resource has been added
        </Alert>
      </Snackbar>
    </div>
  );
};

export default AddForm;
